import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  storeNo: 0,
  cart: [],
  ttl: -1
  // [
  // {
  //   productNo: 0,
  //   optionGroups: [
  //    {
  //      optionGroupNo: 0,
  //      options: [{ optionNo: 0, price: 1 }, { optionNo: 0 }, { optionNo: 0 }]
  //    },
  //    {
  //      optionGroupNo: 0,
  //      options: [{ optionNo: 0 }, { optionNo: 0 }, { optionNo: 0 }]
  //    },
  //    {
  //      optionGroupNo: 0,
  //      options: [{ optionNo: 0 }, { optionNo: 0 }, { optionNo: 0 }]
  //    },
  //   ]
  // }
  // ]
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
